import { Dialog, MenuItem } from '@material-ui/core';
import {
  useSuperMutation,
  useSuperQuery,
  useVerifyAction
} from '@vadiun/react-hooks-legacy';
import ChoferSearchModal from 'app/chofer/components/ChoferSearchModal';
import { ChoferPartialModel } from 'app/chofer/models/Chofer';
import useChoferes from 'app/chofer/services/ChoferService';
import { useViajesTraslado } from 'app/viaje/services';
import PageContainer from 'layout/components/PageContainer';
import PageHeader from 'layout/components/PageHeader';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useQueryClient } from 'react-query';
import { Link } from 'react-router-dom';
import { TransferReservationManagmentModel } from '../../gestion/models/TransferReservationManagment';
import CancelViajeTrasladoModal from '../../viajeTraslado/components/CancelViajeTrasladoModal';
import EndViajeTrasladoModal from '../../viajeTraslado/components/EndViajeTrasladoModal';
import ViajeTrasladoBaseFilters from '../../viajeTraslado/components/ViajeTrasladoBaseFilters';
import ViajeTrasladoResumenModal from '../../viajeTraslado/components/ViajeTrasladoResumenModal';
import { useTransferReservationStore } from '../../viajeTraslado/services/TransferReservationSingleStore';
import { ViajeTrasladoOpenedTable } from '../components/ViajeTrasladoOpenedTable';
import { TransferReservationOpenedModel } from '../models/TransferReservationOpened';
import { BusType } from '../../viajeTraslado/models/TransferReservation';
import BusesPreAssignModal from '../../coordinar/components/buses/pre-assign/BusesPreAssignModal';
import { ViajeTrasladoTipoServicio } from '../../viajeTraslado/models';
import { createTableScrollHandler } from 'utils/tableUtils';
import DriverCanWorkDetails from 'app/chofer/components/DriverCanWorkDetails';
import {
  useOpenedTravel,
  openedTravelColumnLabels,
  getDefaultFilters
} from '../hooks/useOpenedTravel';
import FiltersDrawer from 'shared/components/filters/FiltersDrawer';
import ChipsBar from 'shared/components/filters/ChipsBar';
import RefreshList from 'shared/components/Table/Refresh';
import SearchList from 'shared/components/Table/Search';
import TableToolbar from 'shared/components/Table/TableToolbar';
import ColumnSelector from 'shared/components/Table/actions-buttons/ColumnSelector';
import FiltersButton from 'shared/components/Table/FiltersButton';
import TotalsTrafficLights from 'shared/components/traffic-lights/TotalsTrafficLights';
import { useNotificationsContext } from 'shared/context/notificationContext';

const ViajeTrasladoOpenedPage = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const qc = useQueryClient();
  const { refreshTrafficLights } = useNotificationsContext();
  const transferReservationHelpers = useTransferReservationStore();
  const ViajeTrasladoService = useViajesTraslado();
  const {
    openedTravel,
    reload,
    filters,
    onFiltersChange,
    onSearchChange,
    onChangePage,
    onChangeRowsPerPage,
    onSortChange,
    columnVisibility,
    setColumnVisibility
  } = useOpenedTravel();

  const [showFilters, setShowFilters] = useState(false);
  const driverRepository = useChoferes();
  const verifyAction = useVerifyAction();
  const [reAssignDriverOpen, setReAssignDriverOpen] = useState<{
    isOpen: boolean;
    isContingency: boolean;
  }>({ isOpen: false, isContingency: false });
  const reAssignMutation = useSuperMutation(
    ViajeTrasladoService.reAssignDriver,
    {
      showSpinner: true
    }
  );
  const [selectedReservation, setSelectedReservation] = useState<
    TransferReservationOpenedModel | undefined
  >(undefined);
  const driversQuery = useSuperQuery(driverRepository.getDriversThatCanWork);

  const [isOpenBusesPreAssignModal, setIsOpenBusesPreAssignModal] =
    useState<boolean>(false);

  const [optionsBuses, setOptionsBuses] = useState<BusType[]>([]);
  const [isLoadingDriversCanWork, setIsLoadingDriversCanWork] =
    useState<boolean>(false);
  const [driversCanWork, setDriversCanWork] = useState<ChoferPartialModel[]>(
    []
  );

  const loadDriversCanWork = async () => {
    setIsLoadingDriversCanWork(true);
    const driversCanWork = await driverRepository.getDriversThatCanWork();
    setDriversCanWork(driversCanWork);
    setIsLoadingDriversCanWork(false);
  };

  const onCloseBusesPreAssignModal = useCallback(() => {
    setIsOpenBusesPreAssignModal(false);
  }, []);

  const [locationsDetail, setLocationsDetail] = useState<
    | {
      isOpen: false;
      details: undefined;
    }
    | {
      isOpen: true;
      details: TransferReservationOpenedModel;
    }
  >({ isOpen: false, details: undefined });

  const [cancelReservationModal, setCancelReservationModal] = useState<
    | {
      isOpen: false;
      reservation: undefined;
    }
    | {
      isOpen: true;
      reservation: any;
    }
  >({ isOpen: false, reservation: undefined });

  const [endReservationModal, setEndReservationModal] = useState<
    | {
      isOpen: false;
      reservationId: undefined;
    }
    | {
      isOpen: true;
      reservationId: number;
    }
  >({ isOpen: false, reservationId: undefined });

  const [assignedDriverDetail, setAssignedDriverDetail] = useState<{
    isOpen: boolean;
    details: ChoferPartialModel | undefined;
    busVehicle?: any;
  }>({ isOpen: false, details: undefined });

  const assignDriver = async (driver: ChoferPartialModel) => {
    await reAssignMutation.mutate(selectedReservation!.id, driver.id);
    setReAssignDriverOpen({ isOpen: false, isContingency: false });
    qc.invalidateQueries(['reservas', 'abiertos']);
    reload();
  };

  const openToPendingMutation = useSuperMutation(
    ViajeTrasladoService.openToPending,
    {
      showSpinner: true,
      onMutationFinish: () => {
        reload();
      }
    }
  );

  const copyReservation = async (
    reservation: TransferReservationManagmentModel
  ) => {
    transferReservationHelpers.copy(reservation.id);
  };

  const cancel = async (
    reservationId: number,
    cancelObservation: string,
    cancellationReasonClient: string
  ) => {
    setCancelReservationModal({ reservation: undefined, isOpen: false });
    await cancelReservationMutation.mutate(
      reservationId,
      cancelObservation,
      cancellationReasonClient
    );
    qc.invalidateQueries(['reservas', 'abiertos']);
  };
  const cancelReservationMutation = useSuperMutation(
    ViajeTrasladoService.cancelReservation,
    {
      showSpinner: true,
      onMutationFinish: () => {
        reload();
      }
    }
  );

  const forceEndReservationMutation = useSuperMutation(
    ViajeTrasladoService.forceEnd,
    { showSpinner: true }
  );

  const notifyDelayMutation = useSuperMutation(
    ViajeTrasladoService.notificarDemora,
    {
      showSpinner: true
    }
  );

  const forceReservationEnd = async (
    reservationId: number,
    endObservation: string
  ) => {
    setEndReservationModal({ reservationId: undefined, isOpen: false });
    await forceEndReservationMutation.mutate(reservationId, endObservation);
    qc.invalidateQueries(['reservas', 'abiertos']);
  };

  const getOptionsBuses = useCallback(async () => {
    const buses = await ViajeTrasladoService.getOptionsBuses();
    setOptionsBuses(buses);
  }, [ViajeTrasladoService]);

  useEffect(() => {
    getOptionsBuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadDriversCanWork();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={tableRef}
      className="min-h-screen bg-page-light dark:bg-page-dark"
    >
      <div
        className="sticky top-0 right-0 left-0 flex flex-col "
        style={{
          zIndex: 101,
          marginBottom: '-24px'
        }}
      >
        <PageHeader
          area="Operaciones - Coordinación"
          title="Viajes Abiertos"
          toolbar={
            <TotalsTrafficLights
              onClick={(filter) =>
                onFiltersChange({ ...getDefaultFilters, ...filter })
              }
              filters={filters}
            />
          }
        />
        <TableToolbar
          className="flex w-full bg-page-light dark:bg-page-dark mt-2 px-8"
          chips={
            <ChipsBar filters={filters} onFiltersChange={onFiltersChange} />
          }
          actions={
            <>
              <SearchList value={filters.search} onSearch={onSearchChange} />
              <RefreshList
                onRefreshTable={async () => {
                  await reload();
                  await refreshTrafficLights();
                }}
                isRefreshing={openedTravel.isLoading}
              />
              <ColumnSelector
                columns={columnVisibility}
                onChange={setColumnVisibility}
                columnLabels={openedTravelColumnLabels}
              />
              <FiltersButton
                onClick={() => setShowFilters(true)}
                isActive={showFilters}
              />
            </>
          }
        />
      </div>
      <PageContainer lessMargin>
        <ViajeTrasladoOpenedTable
          handlePageChange={createTableScrollHandler(tableRef)}
          tableQuery={openedTravel}
          columnVisibility={columnVisibility}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onSortChange={onSortChange}
          onLocationsDetails={(reservation) =>
            setLocationsDetail({ isOpen: true, details: reservation })
          }
          onReAssignDriver={(
            travel: TransferReservationOpenedModel,
            isContingency: boolean
          ) => {
            setSelectedReservation(travel);
            setReAssignDriverOpen({ isOpen: true, isContingency });
          }}
          onShowDriverDetails={(driver, busVehicle) => {
            setAssignedDriverDetail({
              isOpen: true,
              details: driversCanWork!.find((d) => d.id === driver.id)!,
              busVehicle
            });
          }}
          onReservationCopy={copyReservation}
          setOpenToPending={(id: number) => {
            verifyAction({
              title: '¿Está seguro que desea pasar este viaje a pendiente?',
              onAccept: () => openToPendingMutation.mutate(id)
            });
          }}
          onForceEnd={(reservation: TransferReservationOpenedModel) => {
            setEndReservationModal({
              isOpen: true,
              reservationId: reservation.id
            });
          }}
          onEditReservation={(travel) =>
            transferReservationHelpers.edit(travel.id)
          }
          onCancelReservation={(
            reservation: TransferReservationOpenedModel
          ) => {
            setCancelReservationModal({
              isOpen: true,
              reservation: reservation
            });
          }}
          onShowTravelDetails={(id) => (
            <Link to={'/main/operations/trip-details/' + id}>
              <MenuItem>Ver detalle</MenuItem>
            </Link>
          )}
          onDelayNotify={(reservation) =>
            notifyDelayMutation.mutate(reservation.id)
          }
          onBusesPreAssign={(travel: any) => {
            setSelectedReservation(travel);
            setIsOpenBusesPreAssignModal(true);
          }}
        />
      </PageContainer>
      <FiltersDrawer
        open={showFilters}
        onClose={() => setShowFilters(false)}
        onClear={() => onFiltersChange(getDefaultFilters())}
      >
        <ViajeTrasladoBaseFilters
          onSubmit={async (filters) => onFiltersChange(filters)}
          initialValues={filters}
          filterByClient
          filterByPreAssignedDriver={false}
          filterByViolet={true}
          optionsBuses={optionsBuses}
        />
      </FiltersDrawer>
      <CancelViajeTrasladoModal
        isOpen={cancelReservationModal.isOpen}
        onClose={() =>
          setCancelReservationModal({ reservation: undefined, isOpen: false })
        }
        cancel={cancel}
        reservation={cancelReservationModal.reservation!}
      />
      <EndViajeTrasladoModal
        isOpen={endReservationModal.isOpen}
        onClose={() =>
          setEndReservationModal({ reservationId: undefined, isOpen: false })
        }
        forceEnd={forceReservationEnd}
        reservationId={endReservationModal.reservationId!}
      />
      <ChoferSearchModal
        driversQuery={driversQuery}
        onSelect={(chofer) => {
          setReAssignDriverOpen({ isOpen: false, isContingency: false });
          verifyAction({
            title: '¿Está seguro que desea re-asignar este viaje?',
            onDeny: () =>
              setReAssignDriverOpen({ isOpen: false, isContingency: false }),
            onAccept: () => assignDriver(chofer)
          });
        }}
        isOpen={reAssignDriverOpen.isOpen}
        handleClose={() =>
          setReAssignDriverOpen({ isOpen: false, isContingency: false })
        }
      />
      {locationsDetail.details && (
        <ViajeTrasladoResumenModal
          isOpen={locationsDetail.isOpen}
          reservation={locationsDetail.details!}
          handleClose={() =>
            setLocationsDetail({ isOpen: false, details: undefined })
          }
        />
      )}
      <Dialog
        open={assignedDriverDetail.isOpen}
        onClose={() =>
          setAssignedDriverDetail({ details: undefined, isOpen: false })
        }
        maxWidth="md"
      >
        {assignedDriverDetail.details && (
          <DriverCanWorkDetails driver={assignedDriverDetail.details} busVehicle={assignedDriverDetail.busVehicle} />
        )}
      </Dialog>
      <BusesPreAssignModal
        isOpen={isOpenBusesPreAssignModal}
        travel={selectedReservation}
        optionsBuses={optionsBuses}
        driversQuery={{
          ...driversQuery,
          data: driversCanWork.filter(
            (driver) =>
              driver?.businessUnit?.name ===
              ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES
          ),
          isLoading: isLoadingDriversCanWork
        }}
        handleClose={onCloseBusesPreAssignModal}
        onSuccesPreAssign={() => reload()}
      />
    </div>
  );
};

export default ViajeTrasladoOpenedPage;
